import React from 'react';

const quotes = [
    "Practice self-care like Medusa, take care of your hair & turn everyone who has wronged you into stone.",
    "I’m gonna scream “AVENGE ME!!!” and then just die of natural causes",
    "Somebody please give 2020 a snickers bar"
]

const Header = () => {
    var quote = quotes[Math.floor(Math.random() * quotes.length)];
    return(
    <div className="Header" >
        <h1>Hey Y'all!</h1>
        <p>{quote}</p>
        
    </div>
    )
}

export default Header;
